import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=30ff2320&"
import script from "./BranchEdit.vue?vue&type=script&lang=js&"
export * from "./BranchEdit.vue?vue&type=script&lang=js&"
import style0 from "./BranchEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports